const stops = [
  [
    'The Breach',
    'The last intact stars guide your first jump. A distant fracture has just begun to spread.',
    '#164d68',
    '#293e70',
    '#061322',
    0.08,
    0.12,
    740,
    220,
    1.25,
  ],
  [
    'Glass Reach',
    'The Core has broken the constellations. Their scattered light still traces the routes home.',
    '#383777',
    '#17636d',
    '#090e24',
    0.18,
    0.2,
    450,
    290,
    1.1,
  ],
  [
    'Ember Drift',
    'Worlds stripped of their cores drift through a belt of cooling embers.',
    '#784322',
    '#50374d',
    '#180e16',
    0.28,
    0.3,
    755,
    400,
    0.95,
  ],
  [
    'Lost Relay',
    'Silent relay stations hang above a world whose distress signal no longer reaches anyone.',
    '#175977',
    '#244862',
    '#041521',
    0.38,
    0.38,
    450,
    390,
    1.3,
  ],
  [
    "The Warden's Gate",
    'A burning fault divides the sky. The Warden holds the only passage into the ruined inner galaxies.',
    '#794228',
    '#715224',
    '#170e17',
    0.48,
    0.5,
    740,
    270,
    1.4,
  ],
  [
    'Redshift Grave',
    'Beyond the gate, a dying sun pulls the remains of its planets into a red spiral.',
    '#792f46',
    '#4b274e',
    '#180916',
    0.58,
    0.58,
    480,
    250,
    1.05,
  ],
  [
    'Severed Threads',
    'The portal network is tearing apart. Violet scars stretch between the surviving stars.',
    '#59347d',
    '#2e4374',
    '#100a23',
    0.68,
    0.68,
    745,
    420,
    0.9,
  ],
  [
    'Hollow Gardens',
    'Once-green worlds have gone dark. The Core is harvesting their last light.',
    '#345946',
    '#34452b',
    '#091710',
    0.78,
    0.75,
    460,
    300,
    1.2,
  ],
  [
    'Last Constellation',
    'The final stars unravel around a shattered world. Every fracture points toward the source.',
    '#71335e',
    '#40397b',
    '#16091e',
    0.9,
    0.85,
    740,
    290,
    1.1,
  ],
  [
    "The Core's Heart",
    'No stars remain beyond this point. The Glitch Core is feeding on the universe itself.',
    '#183d66',
    '#59277b',
    '#030711',
    1,
    0.9,
    600,
    370,
    1.5,
  ],
];

const SECTOR_JOURNEY = stops.map(
  (
    [name, story, primary, secondary, sky, damage, artOpacity, x, y, scale],
    index
  ) => ({
    sector: index + 1,
    name,
    story,
    damage,
    planet: { x, y, scale },
    style: {
      '--sector-primary': primary,
      '--sector-secondary': secondary,
      '--sector-sky': sky,
      '--sector-damage': damage,
      '--sector-art-opacity': artOpacity,
      '--sector-fragment-opacity': 0.18 + damage * 0.5,
    },
  })
);

export const getSectorJourney = (sector = 1) =>
  SECTOR_JOURNEY[Math.max(0, Math.min(9, Math.trunc(Number(sector) || 1) - 1))];
